var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_info_pop"},[_c('van-action-sheet',{attrs:{"title":_vm.title},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"content duty_detail_content"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }